import { G } from '@mobily/ts-belt';

import { GetB2bCompanyDetailsResponse } from '@Common/types/bo/b2b/companies';

type Address = {
  street: string | null;
  city: string | null;
  postalcode: string | null;
  country: string | null;
};

function isSameAddress(firstAddress: Address, secondAddress: Address) {
  return (
    G.isNullable(secondAddress.street) ||
    G.isNullable(secondAddress.city) ||
    G.isNullable(secondAddress.postalcode) ||
    G.isNullable(secondAddress.country) ||
    (firstAddress.street === secondAddress.street &&
      firstAddress.city === secondAddress.city &&
      firstAddress.postalcode === secondAddress.postalcode &&
      firstAddress.country === secondAddress.country)
  );
}

export function isBillingAddressDifferent({
  street,
  city,
  postalcode,
  country,
  billing_street,
  billing_city,
  billing_postalcode,
  billing_country,
}: Pick<
  GetB2bCompanyDetailsResponse,
  | 'street'
  | 'city'
  | 'postalcode'
  | 'country'
  | 'billing_street'
  | 'billing_city'
  | 'billing_postalcode'
  | 'billing_country'
>) {
  return !isSameAddress(
    { street, city, postalcode, country },
    {
      street: billing_street,
      city: billing_city,
      postalcode: billing_postalcode,
      country: billing_country,
    },
  );
}

export function isMailingAddressDifferent({
  street,
  city,
  postalcode,
  country,
  mailing_street,
  mailing_city,
  mailing_postalcode,
  mailing_country,
}: Pick<
  GetB2bCompanyDetailsResponse,
  | 'street'
  | 'city'
  | 'postalcode'
  | 'country'
  | 'mailing_street'
  | 'mailing_city'
  | 'mailing_postalcode'
  | 'mailing_country'
>) {
  return !isSameAddress(
    { street, city, postalcode, country },
    {
      street: mailing_street,
      city: mailing_city,
      postalcode: mailing_postalcode,
      country: mailing_country,
    },
  );
}
